export const productEnquiryFormFields = {
  name: {
    attributes: {
      type: "text",
      id: "name",
      name: "name",
      placeholder: "Name*",
      maxLength: "150",
    },
    validation: [
      {
        check: "required",
        message: "Field is required.",
      },
    ],
    isValid: false,
    isTouched: false,
    errorMessage: "",
    value: "",
  },
  email: {
    attributes: {
      type: "email",
      id: "email",
      name: "email",
      placeholder: "Email ID*",
      maxLength: "150",
    },
    validation: [
      {
        check: "required",
        message: "Field is required.",
      },
      {
        check: "validEmail",
        message: "The e-mail address entered is invalid.",
      },
    ],
    isValid: false,
    isTouched: false,
    errorMessage: "",
    value: "",
  },
  contact: {
    attributes: {
      type: "number",
      id: "contact",
      name: "contact",
      placeholder: "Contact Number*",
      maxLength: "15",
      minLength: "10",
    },
    validation: [
      {
        check: "required",
        message: "Field is required.",
      },
      {
        check: "validMobile",
        message: "The contact number entered is invalid.",
      },
    ],
    isValid: false,
    isTouched: false,
    errorMessage: "",
    value: "",
  },
  pincode: {
    type: "tel",
    value: "",
    validation: [
      {
        check: "required",
        message: "Field is required.",
      },
    ],
    errorMessage: "",
    isTouched: false,

    isValid: false,
    attributes: {
      name: "pincode",
      placeholder: "Pincode*",
      type: "text",
      id: "pincode",
    },
  },
};
